export default __webpack_public_path__ + "static/media/gallery-wip-pommel_04.dfb194b7.jpg";